<div class="input-group">
    <input type="password" class="form-control form-input-box" id= "{{id}}1" placeholder="{{placeholder}}" #input [(ngModel)]="value" [attr.required]=required 
    [attr.minlength]="minlength" [attr.maxlength]="maxlength"
    [ngClass]="{ 'is-invalid': isInvalid}" 
    (focusin)="focusin()">
    <div class="input-group-append">
        <button type="button" class="input-group-text background-color-light password-toggle-btn" #toggler
            [attr.aria-label]="isPasswordVisible ? 'hide password' : 'show password'">
            <i class="fa" [ngClass]="isPasswordVisible ? 'fa-eye' : 'fa-eye-slash'"></i>
        </button>
    </div>
</div>